/**
 * Same eligibility check FeatureFlag.js wraps as a component — extracted so
 * call sites that need the boolean itself (e.g. to choose between two
 * layouts, not just show/hide one) don't have to duplicate the logic.
 */
import { useMemo } from "react";
import { useUserStore } from "./redux/user";
import appConfig from "../appConfig";

export function useFeatureFlag(name) {
  const { user } = useUserStore();

  const userModel = useMemo(() => {
    if (user?.model) {
      return user.model;
    }
    return null;
  }, [user]);

  return useMemo(() => {
    const features = appConfig.featureFlags || {};

    const feature = features.find((feature) => feature.name === name);

    if (!feature) {
      return false;
    }

    if (feature.conditions && feature.conditions.length === 0) {
      return true;
    }

    for (const conditionIdx in feature.conditions) {
      const condition = feature.conditions[conditionIdx];
      if (userModel) {
        if (condition.user) {
          if (
            condition.user.emails &&
            condition.user.emails.includes(userModel.email)
          ) {
            return true;
          } else if (condition.user.role === userModel.role) {
            return true;
          }
        }
        if (condition.org_uuid) {
          if (userModel.current_org_uuid === condition.org_uuid) {
            return true;
          }
        }
      }
    }

    return false;
  }, [userModel, name]);
}

export default useFeatureFlag;
